import { numberToDollars } from '../../../../utils'

const formatValue = (value, isPercentOfPay) =>
  isPercentOfPay ? `${numberToDollars(value, true)}%` : `$${numberToDollars(value, true)}`

// Ignore empty buckets and compare rounded values to match what the UI displays.
export function getTaxTypeSentences({ isPercentOfPay, buckets }) {
  const visibleBuckets = buckets.filter(
    bucket => Math.round(bucket.current) > 0 || Math.round(bucket.recommended) > 0
  )
  const hasChange = visibleBuckets.some(
    ({ current, recommended }) => Math.round(recommended) !== Math.round(current)
  )
  const sentences = visibleBuckets.map(({ label, current, recommended }) => {
    const target = formatValue(recommended, isPercentOfPay)
    const change = Math.round(recommended) - Math.round(current)
    if (change > 0) return `Increase ${label} to ${target}.`
    if (change < 0) return `Decrease ${label} to ${target}.`
    return `Keep ${label} at ${target}.`
  })
  return { sentences, hasChange }
}
